import styled from 'styled-components'
import Modal, { ModalContentWrapper } from 'components/Modal'

export const AddUserModalContainer = styled(Modal)`
  .Overlay {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  ${ModalContentWrapper} {
    width: fit-content;
  }
`

Modal.defaultProps = {
  dataTestId: 'add-user-modal-modal',
}
